import { useEffect } from "react";
import { SectionSkeleton } from "@/components/profile-cards";
import { useCompanyDetails } from "@/hooks/useCompanyDetails";
import { useFetchContractorProfile } from "@/pages/Onboarding/Contractor/hooks/useFetchContractorProfile";
import { useAppStore } from "@/store/app/slice";
import { UserRole } from "@/types/users";
import { CompanyDetails } from "../components/CompanyDetails";
import { Experience } from "./Experience";
import { ServiceAreas } from "./ServiceAreas";

const ContractorDetailsSections = () => {
  const { profile } = useFetchContractorProfile();
  const {
    data: companyDetails,
    loading: companyLoading,
    getCompanyDetails,
  } = useCompanyDetails();

  useEffect(() => {
    if (!profile?.contractingCompanyId) return;

    getCompanyDetails({
      id: profile.contractingCompanyId,
      companyType: "contractor",
    });
  }, [getCompanyDetails, profile]);

  if (!profile || companyLoading) {
    return (
      <>
        <SectionSkeleton />
        <SectionSkeleton />
      </>
    );
  }

  return (
    <>
      <Experience profile={profile} />
      <ServiceAreas
        userId={profile.userId}
        serviceAreas={profile.serviceAreas}
      />
      <CompanyDetails company={companyDetails} companyType="contractor" />
    </>
  );
};

const ContractorDetails = () => {
  const user = useAppStore((s) => s.user);

  if (user?.role !== UserRole.Contractor) return null;

  return <ContractorDetailsSections />;
};

export default ContractorDetails;
